<template>
  <div>
    <dashboard-items-header
      :title="$t('dashboard.general-vision')"
      :periodDays="periodDays"
      @onClickPeriodFilter="onClickPeriodFilterHandler"
    />
    <alarm-general-donut-vision
      ref="alarmGeneralDonutVision"
      :filters="getFilters()"
      @onGraphClick="openAlarmWindow"
    />
    <overview-by-asset-chart
      ref="overviewByAssetChart"
      :filters="getFilters()"
      @onBubbleClick="openAlarmWindow"
    />
  </div>
</template>

<script>
import AlarmGeneralDonutVision from '@/domain/components/generalPanel/dashboard/alarmGeneralVision/AlarmGeneralDonutVision';
import OverviewByAssetChart from '@/domain/components/generalPanel/dashboard/OverviewByAssetChart';
import DashboardItemsHeader from '@/components/header/DashboardItemsHeader';
import periods from '@/domain/enums/periods-dropdown-filter';
import AlarmsReportMixin from '@/domain/mixins/generalPanel/reports/alarmsReportMixin';

export default {
  name: 'DashboardOverview',
  components: {
    AlarmGeneralDonutVision,
    DashboardItemsHeader,
    OverviewByAssetChart,
  },
  props: {
    filters: {
      type: Object,
      default: () => ({}),
      required: true,
    },
  },
  mixins: [AlarmsReportMixin],
  data: () => ({
    periodDays: periods.ALL,
  }),
  methods: {
    openAlarmWindow(params) {
      const filter = {
        companiesIds: this.filters.companiesIds,
        regionalIds: this.filters.regionalsIds,
        installationsIds: this.filters.installationsIds,
        period: this.periodDays,
        ...params,
      };
      this.openAlarmAndWarning(filter);
    },
    onClickPeriodFilterHandler(newPeriod) {
      this.periodDays = newPeriod;

      this.$nextTick(() => {
        this.loadData();
      });
    },
    loadData() {
      this.$refs.alarmGeneralDonutVision.loadChartData();
      this.$refs.overviewByAssetChart.getAlarmsOverviewByAsset();
    },
    getFilters() {
      return {
        ...this.filters,
        periodDays: this.periodDays,
      };
    },
  },
};
</script>
